import React from 'react';
import Confirmation from './ConfirmationModal';
/**
 * @typedef {object} Confirmation
 * @property {string} message
 * @property {string} [title]
 * @property {() => void} [onCancel]
 * @property {() => void} [onConfirm]
 */

/**
 * @type {React.Context<any[]>}
 */
//@ts-ignore - messy, could be done with TS
const ConfirmationContext = React.createContext([]);

const initialState = [];

export const reducer = (state, [type, payload]) => {
  switch (type) {
    case 'ADD':
      return [payload, ...state];

    case 'REMOVE': {
      const [, ...rest] = state;
      return rest;
    }

    case 'CLEAR':
      return initialState;

    default:
      return state;
  }
};

export default function ConfirmationProvider({
  children,
  hideContainer = false,
}) {
  const value = React.useReducer(reducer, initialState);

  return (
    <ConfirmationContext.Provider value={value}>
      {!hideContainer && <ConfirmationContainer />}
      {children}
    </ConfirmationContext.Provider>
  );
}

export function useConfirmation() {
  const [, dispatch] = React.useContext(ConfirmationContext);
  return (confirmation) => dispatch(['ADD', confirmation]);
}

export function ConfirmationContainer() {
  const [[current], dispatch] = React.useContext(ConfirmationContext);
  const remove = () => dispatch(['REMOVE']);
  if (!current) return null;
  return (
    <Confirmation
      message={current.message}
      // TODO: decide whether to add title back to confirmation or remove this line
      // title={current.title}
      onConfirm={() => {
        remove();
        return current.onConfirm?.();
      }}
      onCancel={() => {
        remove();
        return current.onCancel?.();
      }}
    />
  );
}
